export default "__VITE_ASSET__DOTrR6Tt__"